import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Slice, LockCheckout } from './types'

export const initialState: Slice = {}

interface ActionData {
  cartId: string
  value: boolean
}

const getSlice = (slice: LockCheckout): LockCheckout => {
  return slice ?? {}
}

const slice = createSlice({
  name: 'quote/lockCheckout',
  initialState,
  reducers: {
    setLockCheckout (state, action: PayloadAction<ActionData>) {
      const { cartId, value } = action.payload
      const slice = getSlice(state[cartId])
      slice.value = value
      state[cartId] = slice
    }
  }
})

export const reducer = slice.reducer

export const { setLockCheckout } = slice.actions
